





































































import { Component, Vue, PropSync } from "vue-property-decorator";
import { Period } from "@foxone/api/src/models/hfox";
import hfoxUtils from "hfox/utils";

@Component
class PlanPeriodSelect extends Vue {
  @PropSync("period") bindPeriod!: Period;

  periodModal = false;

  // time = "";

  timeDialog = false;

  get time() {
    let { hour, minute } = this.bindPeriod;
    if (hour === null && minute === null) {
      return "";
    }

    hour = Number(hour || "");
    minute = Number(minute || "");
    return `${hour < 10 ? "0" + hour : hour}:${
      minute < 10 ? "0" + minute : minute
    }`;
  }

  set time(value) {
    const [h, m] = value.split(":");
    this.bindPeriod.hour = Number(h);
    this.bindPeriod.minute = Number(m);
  }

  get rules() {
    return {
      period: [v => !!v || this.$t("hfox.plan.preiods.required")]
    };
  }

  get periodText() {
    const { frequency, day, hour } = this.bindPeriod;
    if (frequency === null || hour === null) {
      return "";
    }

    const frequencyItem = this.frequencyItems.find(
      item => item.value === frequency
    );
    const frequencyText = (frequencyItem && frequencyItem.text) || "";

    const dayItem = hfoxUtils.period
      .getDateItems(this.bindPeriod, this)
      .find(item => item.value === day);
    const dayText = (dayItem && dayItem.text) || "";

    // const hourItem = this.hourItems.find(item => item.value === hour);
    const hourText = this.time;

    if (frequency === "Weekly") {
      if (day === null) {
        return "";
      }
      return `${frequencyText}, ${dayText}, ${hourText}`;
    }

    if (frequency === "Monthly") {
      if (day === null) {
        return "";
      }
      return `${frequencyText}, ${dayText}, ${hourText}`;
    }

    if (frequency === "Daily") {
      return `${frequencyText}, ${hourText}`;
    }

    return "";
  }

  get remindText() {
    const { frequency, day, hour } = this.bindPeriod;
    if (frequency === null || hour === null) {
      return "";
    }

    const dayItem = hfoxUtils.period
      .getDateItems(this.bindPeriod, this)
      .find(item => item.value === day);
    const dayText = (dayItem && dayItem.text) || "";

    const hourText = this.time;

    if (frequency === "Weekly") {
      return this.$t("hfox.plan.preiods.reminder.weekly", {
        day: dayText,
        hour: hourText
      });
    }

    if (frequency === "Monthly") {
      return this.$t("hfox.plan.preiods.reminder.monthly", {
        day: dayText,
        hour: hourText
      });
    }

    if (frequency === "Daily") {
      return this.$t("hfox.plan.preiods.reminder.daily", { hour: hourText });
    }
    return "";
  }

  get dateItems() {
    return hfoxUtils.period.getDateItems(this.bindPeriod, this);
  }

  get frequencyItems() {
    return [
      {
        text: this.$t("hfox.plan.frequency.daily"),
        value: "Daily"
      },
      {
        text: this.$t("hfox.plan.frequency.weekly"),
        value: "Weekly"
      },
      {
        text: this.$t("hfox.plan.frequency.monthly"),
        value: "Monthly"
      }
    ];
  }

  get periodHint() {
    if (this.bindPeriod.frequency === "Monthly") {
      return this.$t("hfox.plan.preiods.hint.monthly");
    }
    return "";
  }

  hideTimeDialog() {
    this.timeDialog = false;
  }
}
export default PlanPeriodSelect;
